import * as React from 'react';
export const IcSecureLocked = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zm1.09 10.11l.83 3.14a1 1 0 01-1 1.25h-1.69a1 1 0 01-1-1.21l.68-3.2a.5.5 0 00-.12-.42l-.09-.08A2.25 2.25 0 019.88 9a.781.781 0 010-.14 2.25 2.25 0 011-1h.14l.14-.06a2.3 2.3 0 01.43-.12h.75a2.28 2.28 0 011.87 2.21 2.25 2.25 0 01-.95 1.83.38.38 0 00-.09.09.49.49 0 00-.08.3z'
      fill='currentColor'
    />
  </svg>
);
